export const tabsCarousel = () => ({
    isInViewport: false,
    active: 1,
    buttons: JSON.parse(document.querySelector('.tabs-carousel').dataset.buttons),

    init() {
        this.$nextTick(() => this.initSwiper(1))
    },

    initSwiper(n) {
        const el = this.$refs['swiper' + n]
        if (!el) return

        if (el.swiper) {
            el.swiper.slideTo(0, 0)
            return
        }
        el.initialize()
    },

    show(n) {
        this.active = n
        this.$nextTick(() => this.initSwiper(n))
    },

    isActive(i) {
        return i === this.active
    },
})

